import loadable from '@loadable/component';
import FullPageLoading from '../../components/Loading/FullPageLoading';

export const ExerciseLoadable = loadable(async () => import('./exercise.view'), {
  fallback: <FullPageLoading background="color-dark" />,
});
